(function(){
'use strict';

function chariotWrapper() {
  return {
    restrict: 'E',
    template: '<chariot-connect cid="{{cid}}" theme="{{theme}}"></chariot-connect>',
    scope: {
      cid: '@',
      theme: '@',
      onSuccess: '&',
      onExit: '&',
      onError: '&',
      onDonationRequest: '&',
      validateForm: '&?',
      amount: '&',
      parentModel: '=',
      submit: '&'
    },
    link: function link(scope, element) {
      var connectElem = element.find('chariot-connect')[0];

      if (!connectElem) {
        throw new Error('chariot-connect element not found in the DOM');
      }

      connectElem.onDonationRequest(function () {
        if (typeof scope.validateForm === 'function' && !scope.validateForm()) {
          return false;
        }

        return {
          // eslint-disable-next-line radix
          amount: parseInt(scope.parentModel.items[0].raw_final_price) * 100,
          firstName: scope.parentModel.billing_first_name,
          lastName: scope.parentModel.billing_last_name,
          email: scope.parentModel.member_email_address,
          address: {
            line1: scope.parentModel.billing_address1,
            line2: scope.parentModel.billing_address2,
            city: scope.parentModel.billing_city,
            state: scope.parentModel.billing_state,
            postalCode: scope.parentModel.billing_postal_code
          },
          designation: SC.campaign.designation.name
        };
      });

      connectElem.addEventListener('CHARIOT_SUCCESS', function (e) {
        var detail = e.detail;
        if (detail === null) return false;
        scope.onSuccess({ detail: e.detail });

        return true;
      });

      connectElem.addEventListener('CHARIOT_EXIT', function (e) {
        scope.onExit({ event: e });
      });
    }
  };
}

angular.module('classy').directive('chariotWrapper', chariotWrapper);
})();